export function getAttributeLabel(attribute) {
  switch (attribute) {
    case 'str':
      return 'Força'
    case 'res':
      return 'Resistência'
    case 'dex':
      return 'Destreza'
    case 'agi':
      return 'Agilidade'
    case 'wis':
      return 'Sabedoria'
    case 'int':
      return 'Inteligência'
    default:
      return ''
  }
}

export function getSkillTypeLabel(type) {
  switch (type) {
    case 'atk':
      return 'Ataque'
    case 'sup':
      return 'Suporte'
    case 'pas':
      return 'Passiva'
    case 'def':
      return 'Defesa'
    default:
      return ''
  }
}

export function getSkillCostDescription(cost) {
  if (isNaN(cost)) return 'Todos os PHs'
  if (cost === 0) return ''
  if (cost === 1) return '1 PH'
  if (cost > 1) return `${cost} PHs`
}

export function getSkillLevelLabel(index, type) {
  switch (index) {
    case 0:
      return type === 'race' ? 'Iniciante' : 'Aprendiz'
    case 1:
      return type === 'race' ? 'Normal' : 'Normal'
    case 2:
      return type === 'race' ? 'Soberano' : 'Veterano'
    case 3:
      return type === 'race' ? 'Lendário' : 'Lendário'
    default:
      return ''
  }
}
